import { InjectionToken } from '@angular/core';

export const DOMAIN = new InjectionToken('DOMAIN');
